import React, { useState } from 'react';
import { Popup } from '../../components/Popup';
import { Button } from '../../components/Button';
import { useDispatch } from 'react-redux';
import { createOfficeCategory, deleteOfficeCategory, editOfficeCategory } from '../../redux/officeSlice';
import { Input } from '../../components/Input';
import { getContrastingColor } from '../../helpers';

export const Categories = ({closeFn, list }) => {

    const dispatch = useDispatch();
    
    const CategoryItem = ({name, undeletable, color, _id}) => {

        const [isEdit, setEdit] = useState(false);
        const [thisName, setName] = useState(name);
        const [thisColor, setColor] = useState(color);

        const contrastColor = getContrastingColor(thisColor);

        const cancelHandler = () => {
            setColor(color);
            setEdit(false);
        }
        const saveChangesHandler = () => {
            const obj = {};
            if (thisName !== name) {
                obj.name = thisName;
            }
            if (thisColor !== color) {
                obj.color = thisColor;
            }
            if (!obj.name && !obj.color) return;
            dispatch(editOfficeCategory({...obj, _id}));
            setEdit(false);
        }
        const deleteHandler = () => {
            if (window.confirm(`Удалить категорию "${name}"?`)) {
                dispatch(deleteOfficeCategory(_id));
                setEdit(false);
            }
        }

        return (
            <div
                className={`category-list__item category-item ${isEdit ? 'editing' : ''}`}
                style={{backgroundColor: thisColor}}
                onClick={() => {}}>
                <div className={`category-item__button ${isEdit ? 'editing' : ''}`}>
                    {!isEdit
                    ? <Button disabled={undeletable} text='Изменить' onClick={() => setEdit(true)}/>
                    : <Button text='Отмена' onClick={cancelHandler}/>}
                </div>
                {!isEdit && <div style={{color: contrastColor}}>{name}</div>}
                {isEdit && <Input value={thisName} changeHandler={(evt) => setName(evt.target.value)}/>}
                {isEdit && <Input type='color' value={thisColor} changeHandler={(evt) => setColor(evt.target.value)} />}
                <div className={`category-item__button ${isEdit ? 'editing' : ''}`}>
                    {isEdit
                    ? <Button text='Сохранить' onClick={saveChangesHandler}/>
                    : <Button disabled={undeletable} text='Удалить' onClick={deleteHandler}/>}
                </div>
            </div>
        );
    };

    const [create, setCreate] = useState(false);
    const [categoryName, setCategoryName] = useState('');
    const [categoryColor, setCategoryColor] = useState('#ffffff');

    const createCategoryHandler = () => {
        if (!categoryName || !categoryColor) return;
        dispatch(createOfficeCategory({name: categoryName, color: categoryColor}));
        setCategoryName('');
        setCategoryColor('#ffffff');
        setCreate(false);
    }

    return (
        <Popup
            title='Категории'
            closeFn={closeFn}
            button={<Button text={`Закрыть`} onClick={closeFn} />}>
            <div className='office__categories'>
                <div className="category-list">
                    {list.map(c => <CategoryItem key={c._id} undeletable={c.details.undeletable} name={c.name} color={c.details.color} _id={c._id} />)}
                    {create && <div className='category-create category-item'>
                        <Input placeholder='Название' value={categoryName} changeHandler={(evt) => setCategoryName(evt.target.value)} />
                        <Input type='color' value={categoryColor} changeHandler={(evt) => setCategoryColor(evt.target.value)}/>
                        <Button text='Создать' onClick={createCategoryHandler}/>
                    </div>}
                    {!create 
                        ?<Button text='Создать категорию' onClick={() => setCreate(true)}/>
                        :<Button text='Отмена' onClick={() => setCreate(false)}/>}
                </div>
            </div>
        </Popup>
    );
};
